import type { AxiosResponse } from "axios";

/**
 * CANNOT BE USED IN FORMWITHVALIDATION, because the field errors are not shown then (because the error is not thrown)
 * Use in pinia stores for loading actions but not for forms
 *
 * Wraps an async function in a try catch block that returns the data or an error
 * @param promise
 */
export async function withErrorHandling<T>(
  promise: Promise<AxiosResponse<T>>,
): Promise<{ data: T | undefined; error: Error | undefined }> {
  try {
    const response = await promise;
    return { data: response.data, error: undefined };
  } catch (err: unknown) {
    // Narrow unknown to Error if possible
    if (err instanceof Error) {
      return { data: undefined, error: err };
    }
    // Otherwise, create a generic Error
    return { data: undefined, error: new Error(String(err)) };
  }
}
